import { Component, forwardRef, Inject, OnInit, ViewChild } from "@angular/core";
import { NgForm } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from "@angular/material/dialog";
import * as moment from 'moment';
import { firstValueFrom } from "rxjs";
import { PaymentDialogMode, PaymentStatus, SubscriptionSetPaymentDialogComponent } from "../../dashboard-area/subscription-set/subscription-set-payment-dialog.component";
import { SubscriptionSetPayment } from "../../model";
import { AuthenticationService } from "../../service/authentication.service";
import { SubscriptionSetService } from "../../service/subscription-set.service";
import { ErrorUtility } from "../../utility/error-utility";
import { SnackbarService } from "../shared/snackbar.service";
import { SubscriptionSetPaymentDetails } from "./subscription-set-payment-details.component";

@Component({
    selector: 'subscription-set-payment-details-dialog',
    template: require('./subscription-set-payment-details-dialog.component.html'),
    styles: [`
        label {
            margin-bottom: 5px;
        }    
    `]
})
export class SubscriptionSetPaymentDetailsDialogComponent implements OnInit {

    @ViewChild('form') form: NgForm;

    payment: SubscriptionSetPayment;
    isOrganizationUser: boolean;
    detailRows: SubscriptionSetPaymentDetails[] = [];
    timezone: string;
    locale: string;
    paymentMoment: moment.Moment;
    maxDate = new Date();
    newStyleManagerEnabled: boolean;
    saving: boolean;

    constructor(
        @Inject(forwardRef(() => MatDialogRef)) private dialogRef: MatDialogRef<SubscriptionSetPaymentDetailsDialogComponent>,
        @Inject(forwardRef(() => SubscriptionSetService)) private subscriptionSetService: SubscriptionSetService,
        @Inject(forwardRef(() => AuthenticationService)) private authenticationService: AuthenticationService,
        @Inject(forwardRef(() => MatDialog)) private dialog: MatDialog,
        @Inject(forwardRef(() => SnackbarService)) private snackbarService: SnackbarService,
        @Inject(MAT_DIALOG_DATA) data
    ) {
        this.payment = data.payment;
        if (this.payment.paymentTimestamp) {
            this.paymentMoment = moment(this.payment.paymentTimestamp);
        }
    }

    ngOnInit(): void {
        this.isOrganizationUser = this.authenticationService.isOrganizationUser();
        this.newStyleManagerEnabled = this.authenticationService.isNewStyleManagerEnabled();
        for (let item of this.payment.items || []) {
            let detailRow = this.detailRows.find(r => r.category == item.category && r.operation == item.operation);
            if (detailRow) {
                detailRow.amount += item.amount;
                detailRow.quantity++;
            } else {
                this.detailRows.push({ quantity: 1, amount: item.amount, category: item.category, operation: item.operation });
            }
        }
    }

    confirm(): void {
        let body = this.form.form.getRawValue();
        let paymentMoment = body.paymentMoment;
        if (paymentMoment) {
            body.paymentTimestamp = paymentMoment.valueOf();
        }
        this.saving = true;
        this.subscriptionSetService.updatePaymentStatus(this.payment.id, body).then(() => {
            this.dialogRef.close(true); 
        }).catch(err => {
            this.saving = false;
            this.snackbarService.showSnackbar(ErrorUtility.getMessage(err), 'notification-error');
        });
    }

    payNow(): void {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.autoFocus = false;
        dialogConfig.width = '470px';
        dialogConfig.data = {
            paymentPresent: true,
            paymentBody: this.payment,
            mode: PaymentDialogMode.RETRY_PAYMENT
        };
        firstValueFrom(this.dialog.open(SubscriptionSetPaymentDialogComponent, dialogConfig).afterClosed()).then(result => {
            if (result?.outcome == PaymentStatus.SUCCESS) {
                this.dialogRef.close(true);
            } else if (result?.outcome == PaymentStatus.FAILED) {
                this.snackbarService.showSnackbar('Something went wrong with payment.\n' + result.message, 'notification-error');
            }
        });
    }

    getPaidBy(): string {
        if (this.payment.creationUserFullName) {
            return `${this.payment.creationUserFullName} (${this.payment.creationUserEmail})`
        }
        return this.payment.creationUserEmail;
    }

}